// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
const DateHelper = require('utilities/dateHelper');
const {
    recordProcess,
    PROC_END,
    PROC_FAIL,
    PROC_RA_CANCEL_CONTRIBUTIONS,
} = require('utilities/tagging');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const raErrorHandlerActions = require('./RAErrorHandler');
const { outdateMyInvestments } = require('actions/brokerMyInvestments');

// @constants
const actionTypes = require('../raConstants/actionTypes');
const { DATE_FORMAT_API, EURO_TEXT } = require('constants/index');

const cancelPeriodicContributionsInProgress = () => ({
    type: actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_REQUEST,
});

const cancelPeriodicContributionsSuccess = data => ({
    type: actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_SUCCESS,
    payload: {
        data,
    },
});

const cancelPeriodicContributionsFailure = error => ({
    type: actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_FAILURE,
    payload: {
        error,
    },
});

const cancelPeriodicContributions = (
    dispatch,
    getState,
    dataToken,
    portfolioId,
    history,
) => {
    const immGlobalPosition = getState().raGlobalPosition;
    const immAccount = immGlobalPosition.getIn(['roboAccount', portfolioId]);
    const immPortfolio = immGlobalPosition.getIn(['portfolios', portfolioId]);

    const params = {
        portfolioId,
    };

    const nextDate = immPortfolio.getIn([
        'recurringTransfers',
        'nextTransferDate',
    ]);
    const nextDateFormatted = !nextDate
        ? '9999-12-31'
        : DateHelper.formatDate(nextDate, DATE_FORMAT_API);

    const requestData = {
        query: {
            contratoOrdenante: {
                numerodecontrato: immPortfolio.getIn([
                    'recurringTransfers',
                    'originalAccount',
                    'contrato',
                ]),
                producto: immPortfolio.getIn([
                    'recurringTransfers',
                    'originalAccount',
                    'documento',
                ]),
            },
            cuentaDestino:
                immAccount.getIn(['ibanComplex', 'pais']) +
                immAccount.getIn(['ibanComplex', 'digitodecontrol']) +
                immAccount.getIn(['ibanComplex', 'codbban']),
            dataToken,
            fechaProximaEjecucion: nextDateFormatted,
            importe: {
                divisa: EURO_TEXT,
                importe: immPortfolio.getIn(['recurringTransfers', 'amount']),
            },
            indicadorDifPerio: 'P',
            numeroOrdenCabecera: immPortfolio.getIn([
                'recurringTransfers',
                'paymentReference',
            ]),
        },
    };

    const customData = {
        processDetail: 'robo cartera ' + immPortfolio.get('name'),
        amount: immPortfolio.getIn(['recurringTransfers', 'amount']),
    };
    const isSecondVersion = true;

    return APIPost(
        dispatch,
        apiURLBuilder.getURL('raCancelPeriodicContributions', params),
        requestData,
    )
        .then(response => {
            dispatch(cancelPeriodicContributionsSuccess(response));
            dispatch(outdateMyInvestments());
            recordProcess(
                PROC_RA_CANCEL_CONTRIBUTIONS,
                PROC_END,
                customData,
                isSecondVersion,
            );
        })
        .catch(error => {
            dispatch(cancelPeriodicContributionsFailure());
            dispatch(raErrorHandlerActions.show(error, history));

            recordProcess(
                PROC_RA_CANCEL_CONTRIBUTIONS,
                PROC_FAIL,
                customData,
                isSecondVersion,
            );
        });
};

const finish = (history, portfolioId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        cancelPeriodicContributions(
            dispatch,
            getState,
            dataToken,
            portfolioId,
            history,
        );
    };

    dispatch(cancelPeriodicContributionsInProgress());
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const reset = () => ({
    type: actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_RESET,
});

const setVisibleStep = step => ({
    type: actionTypes.RA_CANCEL_PERIODIC_CONTRIBUTIONS_SET_VISIBLE_STEP,
    payload: {
        step,
    },
});

module.exports = {
    finish,
    reset,
    setVisibleStep,
};
